import api from "@/services/api";
import track from "@/utils/segment";
import identifyPage from "@/utils/identifyPage";

function calendly(calendlyUrl, segmentData) {
    track(segmentData.event, {
        action: 'click',
        cta_location: segmentData.cta_location,
        cta_page: identifyPage(window.location.href),
    });

    let userData = api.clientData();
    let calendlyParams = {
        utm_campaign: 'landing_page',
        utm_source: userData.user_id,
        utm_medium: userData.site_access_id,
    };

    let urlParams =  Object.keys(calendlyParams).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(calendlyParams[k])).join('&');
    
    window.open(`${calendlyUrl}?${urlParams}`, '_blank');
}

function purchase(segmentData) {
    track(segmentData.event, {
        action: 'click',
        cta_location: segmentData.cta_location,
        cta_page: identifyPage(window.location.href),
    });
}

function faq(segmentData) {
    track(segmentData.event, {
        action: 'click',
        cta_location: segmentData.cta_location,
        cta_page: identifyPage(window.location.href),
    });
}

function feature(segmentData) {
    track(segmentData.event, {
        action: 'click',
        cta_location: segmentData.cta_location,
        cta_page: identifyPage(window.location.href),
    });
}

function testimony(segmentData) {
    track(segmentData.event, {
        action: 'click',
        cta_location: segmentData.cta_location,
        cta_page: identifyPage(window.location.href),
    });
}

export default {calendly, purchase, faq, feature, testimony};
